import React, { Fragment, Suspense } from "react";
import { BrowserRouter as Router } from "react-router-dom";
import { Routes } from "react-router-dom";
import { ConfigProvider } from "antd"; // وارد کردن ConfigProvider
import faIR from "antd/locale/fa_IR"; // وارد کردن بسته زبان فارسی
import routes, { renderRoutes } from "./routes";
import { AuthProvider } from "./context/AuthContext"; // فرض بر وجود AuthProvider

import "antd/dist/reset.css"; // استایل‌های پایه Ant Design
import "./App.css";

const loading = (
  <div className="pt-3 text-center">
    <div className="sk-spinner sk-spinner-pulse">loading</div>
  </div>
);

function App() {
  return (
    // App را با AuthProvider و ConfigProvider包裹 کنید
    <AuthProvider>
      <ConfigProvider direction="rtl" locale={faIR}>
        <Router basename={""}>
          <Suspense fallback={loading}>
            <Routes>{renderRoutes(routes, Fragment, Fragment)}</Routes>
          </Suspense>
        </Router>
      </ConfigProvider>
    </AuthProvider>
  );
}

export default App;
